/** 浏览器标签页标题 */
export const APP_TITLE = '海湾镇志编纂AI文档管理系统'

/** 对外展示的系统版本号 */
export const APP_VERSION = '1.5.0'
